import {
    Video,
    electronConfig,
    convertPath,
    isElectron,
    strTest
} from "../../libs/roomnew";
import AppleAuth from "../Apple/AppleAuth";

//Uncomment electron
// import { startFacebookSignin } from "../../../renderer/libs/Auth/Facebook/FacebookSignIn";
// import { startGoogleSignin } from "../../../renderer/libs/Auth/Google/GoogleSignIn";
// import { startAppleSignin } from "../../../renderer/libs/Auth/Apple/AppleSingIn";
// import { getData, setUser } from "../../../renderer/libs/user";

export default class LoginModal{
    constructor(){
        this.modal = null;
        this.timeout = 0;

        //Buttons and svg-s
        this.closeModalIcon = `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>`;
        this.googleIcon = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Capa_1" style="enable-background:new 0 0 150 150;" version="1.1" viewBox="0 0 150 150" xml:space="preserve"><style type="text/css"> .st0{fill:#1A73E8;} .st1{fill:#EA4335;} .st2{fill:#4285F4;} .st3{fill:#FBBC04;} .st4{fill:#34A853;} .st5{fill:#4CAF50;} .st6{fill:#1E88E5;} .st7{fill:#E53935;} .st8{fill:#C62828;} .st9{fill:#FBC02D;} .st10{fill:#1565C0;} .st11{fill:#2E7D32;} .st12{fill:#F6B704;} .st13{fill:#E54335;} .st14{fill:#4280EF;} .st15{fill:#34A353;} .st16{clip-path:url(#SVGID_2_);} .st17{fill:#188038;} .st18{opacity:0.2;fill:#FFFFFF;enable-background:new    ;} .st19{opacity:0.3;fill:#0D652D;enable-background:new    ;} .st20{clip-path:url(#SVGID_4_);} .st21{opacity:0.3;fill:url(#_45_shadow_1_);enable-background:new    ;} .st22{clip-path:url(#SVGID_6_);} .st23{fill:#FA7B17;} .st24{opacity:0.3;fill:#174EA6;enable-background:new    ;} .st25{opacity:0.3;fill:#A50E0E;enable-background:new    ;} .st26{opacity:0.3;fill:#E37400;enable-background:new    ;} .st27{fill:url(#Finish_mask_1_);} .st28{fill:#FFFFFF;} .st29{fill:#0C9D58;} .st30{opacity:0.2;fill:#004D40;enable-background:new    ;} .st31{opacity:0.2;fill:#3E2723;enable-background:new    ;} .st32{fill:#FFC107;} .st33{opacity:0.2;fill:#1A237E;enable-background:new    ;} .st34{opacity:0.2;} .st35{fill:#1A237E;} .st36{fill:url(#SVGID_7_);} .st37{fill:#FBBC05;} .st38{clip-path:url(#SVGID_9_);fill:#E53935;} .st39{clip-path:url(#SVGID_11_);fill:#FBC02D;} .st40{clip-path:url(#SVGID_13_);fill:#E53935;} .st41{clip-path:url(#SVGID_15_);fill:#FBC02D;}</style><g><path class="st14" d="M120,76.1c0-3.1-0.3-6.3-0.8-9.3H75.9v17.7h24.8c-1,5.7-4.3,10.7-9.2,13.9l14.8,11.5   C115,101.8,120,90,120,76.1L120,76.1z"/><path class="st15" d="M75.9,120.9c12.4,0,22.8-4.1,30.4-11.1L91.5,98.4c-4.1,2.8-9.4,4.4-15.6,4.4c-12,0-22.1-8.1-25.8-18.9   L34.9,95.6C42.7,111.1,58.5,120.9,75.9,120.9z"/><path class="st12" d="M50.1,83.8c-1.9-5.7-1.9-11.9,0-17.6L34.9,54.4c-6.5,13-6.5,28.3,0,41.2L50.1,83.8z"/><path class="st13" d="M75.9,47.3c6.5-0.1,12.9,2.4,17.6,6.9L106.6,41C98.3,33.2,87.3,29,75.9,29.1c-17.4,0-33.2,9.8-41,25.3   l15.2,11.8C53.8,55.3,63.9,47.3,75.9,47.3z"/></g></svg>`;
        this.facebookIcon = `<svg aria-hidden="true" class="svg-icon" width="18" height="18" viewBox="0 0 18 18"><path d="M1.88 1C1.4 1 1 1.4 1 1.88v14.24c0 .48.4.88.88.88h7.67v-6.2H7.46V8.4h2.09V6.61c0-2.07 1.26-3.2 3.1-3.2.88 0 1.64.07 1.87.1v2.16h-1.29c-1 0-1.19.48-1.19 1.18V8.4h2.39l-.31 2.42h-2.08V17h4.08c.48 0 .88-.4.88-.88V1.88c0-.48-.4-.88-.88-.88H1.88z" fill="#fff"></path></svg>`;
        this.appleIcon = `<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="842.32007" viewBox="0 0 842.32007 1000.0001" version="1.1" height="1000.0001" id="svg2"><path d="m 824.66636,779.30363 c -15.12299,34.93724 -33.02368,67.09674 -53.7638,96.66374 -28.27076,40.3074 -51.4182,68.2078 -69.25717,83.7012 -27.65347,25.4313 -57.2822,38.4556 -89.00964,39.1963 -22.77708,0 -50.24539,-6.4813 -82.21973,-19.629 -32.07926,-13.0861 -61.55985,-19.5673 -88.51583,-19.5673 -28.27075,0 -58.59083,6.4812 -91.02193,19.5673 -32.48053,13.1477 -58.64639,19.9994 -78.65196,20.6784 -30.42501,1.29623 -60.75123,-12.0985 -91.02193,-40.2457 -19.32039,-16.8514 -43.48632,-45.7394 -72.43607,-86.6641 C 77.707522,829.30207 52.171259,778.62464 32.165691,720.84861 10.740416,658.44309 0,598.01283 0,539.50845 0,472.49197 14.481044,414.69125 43.486336,366.25444 66.28194,327.34823 96.60818,296.6578 134.5638,274.1276 c 37.95566,-22.53016 78.96676,-34.01129 123.1321,-34.74585 24.16591,0 55.85633,7.47508 95.23784,22.166 39.27042,14.74029 64.48571,22.21538 75.54091,22.21538 8.26518,0 36.27668,-8.7405 83.7629,-26.16587 44.90607,-16.16001 82.80614,-22.85118 113.85458,-20.21546 84.13326,6.78992 147.34122,39.95559 189.37699,99.70686 -75.24463,45.59122 -112.46573,109.4473 -111.72502,191.36456 0.67899,63.8067 23.82643,116.90384 69.31888,159.06309 20.61664,19.56727 43.64066,34.69027 69.2571,45.4307 -5.55531,16.11062 -11.41933,31.54225 -17.65372,46.35662 z M 631.70926,20.0057 c 0,50.01141 -18.27108,96.70693 -54.6897,139.92782 -43.94932,51.38118 -97.10817,81.07162 -154.75459,76.38659 -0.73454,-5.99983 -1.16045,-12.31444 -1.16045,-18.95003 0,-48.01091 20.9006,-99.39207 58.01678,-141.40314 C 497.65157,54.696 521.21876,37.0095 549.79815,22.90064 578.3158,9.00229 605.2903,1.31621 630.65988,0 c 0.74076,6.68575 1.04938,13.37191 1.04938,20.00505 z" id="path4" inkscape:connector-curvature="0" style="stroke-width:0.84231985;fill:#b3b3b3;fill-opacity:1" /></svg>`;
        this.showPasswordIcon = `<svg class="mui-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>`;
        this.hidePasswordIcon = `<svg class="mui-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></svg>`;
        this.appleAuth=new AppleAuth();
        this.events();
    }

    events(){

    }

    renderModal(){
        let lm = this;

        lm.alternativeSignUp = $('<span/>',{
            class: 'ml-1',
            style: 'text-decoration: underline; cursor: pointer;',
            html: 'SIGN UP',
        }).on('click', function(){
            if(isElectron){
                // we have to add functionality for desktop to open the side drawer with the sign up page
                window.open(`${api.global.app_url}/signup`, '_blank');
            }else{
                window.location.replace('/signup');
            }
        })
        lm.alternativeAuth = $('<div/>',{
            class: 'd-flex mb-2 mt-2 text-center justify-content-center w-100 ignore-drag',
            html: ['Not a member? ', lm.alternativeSignUp]
        })
        lm.googleContainer = $('<button/>',{
            class: 'auth-providers google ignore-drag',
            html:[lm.googleIcon, 'Sign in with Google']
        }).on('click',function(){
            if(isElectron){
                // we have to add functionality for desktop to open the side drawer with the sign up page
                startGoogleSignin();
            }else{
                window.location.href = `/signin/google?redirect_url=${window.location.href}`;
            }
        })

        lm.facebookContainer = $('<button/>',{
            class: 'auth-providers facebook ignore-drag',
            html:[lm.facebookIcon, 'Sign in with Facebook']
        }).on('click',function(){
            if(isElectron){
                // we have to add functionality for desktop to open the side drawer with the sign up page
                startFacebookSignin();
            }else{
                window.location.href = `/signin/facebook?redirect_url=${window.location.href}`;
            }
        })

        lm.appleContainer = $('<button/>',{
            class: 'auth-providers apple ignore-drag',
            html:[lm.appleIcon, 'Sign in with Apple']
        }).on('click',function(){
            if(isElectron){
                // we have to add functionality for desktop to open the side drawer with the sign up page
                startAppleSignin();
            }else{
                lm.appleAuth.handleSubmit();
            }
        })

        lm.socials = $('<div/>', {
            class: 'd-flex flex-column',
            html: [lm.googleContainer, lm.facebookContainer, lm.appleContainer]
        })

        lm.divider = $('<div/>',{
            class: 'd-flex w-100 justify-content-center text-center',
            html: 'OR'
        })

        //sign in button container
        lm.emptyDiv = $('<div/>',{
            class: 'w-100 text-center pb-2 pt-2',
            html: ''
        })
        lm.signInButton = $('<button/>',{
            class: 'btn btn-primary btn-block kino-btn-primary ignore-drag',
            type: 'button',
            html: 'SIGN IN',
            tabindex:4
        }).on('click', function(){
            lm.signIn();
        })
        lm.signInContainerInner = $('<div/>',{
            class: 'col-md-12',
            html: lm.signInButton
        })
        lm.signInContainer = $('<div/>',{
            class: 'form-group d-flex flex-column justify-content-start mb-0',
            html: [lm.signInContainerInner, lm.emptyDiv]
        })

        //forgot section
        lm.forgotLink = $('<a/>',{
            class: 'btn btn-link ignore-drag',
            href: `${isElectron ? api.global.app_url : ''}/password/reset`,
            target: '_blank',
            html: 'Forgot password?'
        })
        lm.forgotSection = $('<div/>',{
            class: 'col-md-6 push-right text-right pr-0 ignore-drag',
            html: lm.forgotLink
        })
        lm.rememberMeLabel = $('<label/>',{
            class: "form-check-label ignore-drag",
            for: "remember",
            html: 'Remember Me'
        })
        lm.rememberMeInput = $('<input/>',{
            class: 'form-check-input ignore-drag',
            type: "checkbox",
            name: "remember",
            id: "remember",
            tabindex:3
        })
        lm.rememberMeSectionInner = $('<div/>',{
            class: 'form-check',
            html: [lm.rememberMeInput, lm.rememberMeLabel]
        })
        lm.rememberMeSection = $('<div/>',{
            class: 'col-md-6',
            html: isElectron ? '' : lm.rememberMeSectionInner
        })
        lm.actionsSection = $('<div/>',{
            class: 'form-group mb-2 d-flex align-items-center justify-content-start',
            html: [lm.rememberMeSection, lm.forgotSection]
        })

        //password field
        lm.passwordErrors = $('<div/>',{
            class: 'error_kino ignore-drag',
            style: 'position: absolute;',
            html: ''
        })
        lm.showHidePasswordInput = $('<input/>',{
            type: 'checkbox',
            class: 'kino-checkbox',
        }).on('change', function(){
            if($(this).is(':checked')){
                lm.showHidePasswordIcon.html(lm.showPasswordIcon)
                lm.passwordInput.attr('type','text')
            }else{
                lm.showHidePasswordIcon.html(lm.hidePasswordIcon)
                lm.passwordInput.attr('type','password')
            }
        })
        lm.showHidePasswordIcon = $('<span/>',{
            class: '',
            html: lm.hidePasswordIcon
        })
        lm.showHidePassword = $('<label/>',{
            class: 'show-hide-password ignore-drag',
            html: [lm.showHidePasswordInput, lm.showHidePasswordIcon]
        })
        lm.passwordInput = $('<input/>',{
            type: 'password',
            class: 'modified-auth-input h-40 form-control ignore-drag',
            name:"password",
            required : true,
            placeholder: 'Password',
            tabindex:2
        }).on('keyup', function(e){
            if(e.keyCode === 13){
                lm.signIn();
            }
        })
        lm.passwordContainerInner = $('<div/>',{
            class: 'col-md-12 mb-2 auth-input-container',
            html: [lm.showHidePassword, lm.passwordInput, lm.passwordErrors]
        })
        lm.passwordContainer = $('<div/>',{
            class: 'form-group mb-3 d-flex flex-column justify-content-start',
            html: lm.passwordContainerInner
        })

        //email field
        lm.emailErrors = $('<div/>',{
            class: 'error_kino ignore-drag',
            style: 'position: absolute;',
            html: ''
        })
        lm.emailInput = $('<input/>',{
            type: 'email',
            class: 'modified-auth-input h-40 form-control ignore-drag',
            name: "email",
            value: "",
            required: true,
            autofocus: true,
            placeholder: "Email address",
            tabindex:1
        }).on('keyup', function(e){
            if(e.keyCode === 13){
                lm.signIn();
            }
        })
        lm.emailContainerInner = $('<div/>',{
            class: 'col-md-12 mb-3',
            html: [lm.emailInput, lm.emailErrors]
        })
        lm.emailContainer = $('<div/>',{
            class: 'form-group mb-2 d-flex flex-column align-items-start',
            html: lm.emailContainerInner
        })

        // lm.UtcTimeInput = $('<input/>',{
        //     type: 'hidden',
        //     name: "utcOffset",
        //     class: "utcOffset",
        //     value: `${moment.tz.guess()}`
        // })
        lm.signInForm = $('<div/>',{
            class: 'd-flex flex-column',
            html: [/*lm.UtcTimeInput,*/ lm.emailContainer, lm.passwordContainer, lm.actionsSection, lm.signInContainer]
        })

        lm.generalErrorMessage = $('<div/>',{
            class: 'error_kino text-center mb-1 ignore-drag',
            id: 'signInModalWelcomeGeneralError',
            html: ''
        })
        lm.modalBodyContents = $('<div/>',{
            class: 'col-md-12 login-form-content',
            html: [lm.generalErrorMessage, lm.signInForm, lm.divider, lm.socials, lm.alternativeAuth]
        })
        lm.modalBodyInner = $('<div/>',{
            class: 'row justify-content-center',
            html: lm.modalBodyContents
        })
        lm.modalBody = $('<div/>',{
            class: 'container-fluid',
            html: lm.modalBodyInner
        })

        lm.closeModalButton = $('<button/>',{
            type: 'button',
            class: 'close-button-modal-kino',
            'data-dismiss': 'modal',
            'aria-label': 'Close',
            html: lm.closeModalIcon
        }).on('click', function(){
            lm.removeModal();
        })
        lm.modalTitle = $('<h5/>',{
            class: 'modal-title w-100 f-w-600 text-center custom-modal-title',
            html: 'SIGN IN'
        })
        lm.modalHeader = $('<div/>',{
            class: 'modal-header mb-3 h-auto border-0',
            html: [lm.modalTitle, lm.closeModalButton]
        })
        lm.modalContents = $('<div/>',{
            class: 'modal-content login-modal auth-modals',
            html: [lm.modalHeader, lm.modalBody]
        })
        lm.modalDialog = $('<div/>',{
            class: 'modal-dialog modal-dialog-centered',
            html: lm.modalContents
        })
        lm.modal = $('<div/>',{
            class: "modal fade",
            id: "signInModalWelcome",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "signInModalWelcome",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: lm.modalDialog
        }).on('hidden.bs.modal', function () {
            //fire events when the modal is being closed

        }).on('shown.bs.modal', function () {
            //fire events when the modal is being shown
            lm.emailInput.focus();
        })

        $('body').append(lm.modal);
        lm.modal.modal('show');
    }

    removeModal(){
        let lm = this;
        if(lm.modal){
            setTimeout(() => {
                lm.modal.remove();
            }, 200);
        }
    }

    async signIn(){
        let lm = this;
        let mail = lm.emailInput.val();
        let pw = lm.passwordInput.val();
        let rememberMe = isElectron ? true : lm.rememberMeInput.is(':checked');
        lm.disableJoinButton();

        // console.log('Is valid email', strTest.isValidEmail(mail))
        lm.emailErrors.html('');
        lm.passwordErrors.html('');
        lm.generalErrorMessage.html('');

        if(!mail || !pw || !strTest.isValidEmail(mail)){
            clearTimeout(lm.timeout);
            lm.enableButton();
            if(!strTest.isValidEmail(mail)){
                lm.emailErrors.html('⚠ Invalid email address');
            }
            if(!mail){
                lm.emailErrors.html('⚠ Email is required')
            }
            if(!pw){
                lm.passwordErrors.html('⚠ Password is required')
            }
        }else{
            if(isElectron){
                await axios.get(convertPath('/auth/signout') , await electronConfig()).then(res =>{
                }).catch(err => {
                });
            }else{
                await axios.post('/logout',{}).then(res =>{
                }).catch(err => {
                });
            }


            axios.post(convertPath(`${isElectron ? '/auth/signin' : '/login'}`), {
                email: mail,
                password: pw,
                remember_me: rememberMe
            }, await electronConfig()).then(async function(response){
                let data = response.data;
                console.log(data);
                if(data.error){
                    if(data.error == "Email verification is required"){
                        lm.emailErrors.html(`<div id="email-error-sign-in-as-host-inner">⚠ Email verification is required, <a href="${isElectron ? api.global.app_url: ''}/signIn" style="color:red;">Click to verify from Homepage</a></div>`);
                    }else{
                        lm.generalErrorMessage.html('⚠ '+ data.error);
                    }
                    clearTimeout(lm.timeout);
                    lm.enableButton();
                }else{
                    if(isElectron){
                        await setUser(data);
                        await getData();
                    }
                    window.location.reload();
                    clearTimeout(lm.timeout);
                }
            }).catch(function(err){
                console.log(err.response);
                clearTimeout(lm.timeout);
                lm.enableButton();
                const data = err.response?.data;
                lm.generalErrorMessage.html('⚠ '+ (data?.error ?? "An error occurred, please try again"));
            });
        }
    }

    disableJoinButton(){
        let lm = this;
        lm.signInButton.attr('disabled', 'disabled');
        lm.signInButton.html(`<svg class="circular"><circle class="path" cx="10" cy="10" r="8" fill="none" stroke-width="2" stroke-miterlimit="10" /></svg> please wait...`);
        lm.timeout = setTimeout(() => {
            lm.enableButton();
        }, 10000);
    }
    enableButton(){
        let lm = this;
        lm.signInButton.removeAttr('disabled');
        lm.signInButton.html('SIGN IN');
    }
}
